import React from 'react';
import { getAttendanceColor, getAttendanceBorderColor } from '../../../utils/calendarUtils';
import { triggerFestivalCelebration } from '../../../utils/celebrationConfetti';
import './Calendar.css';

const DayCell = ({ date, attendance, festival: propFestival, isCurrentMonth, isToday, onClick }) => {
  if (!isCurrentMonth) {
    return <div className="day-cell empty-cell" style={{ visibility: 'hidden' }}></div>;
  }
  const dayNumber = date.getDate();
  const status = attendance?.status;
  const festival = propFestival || attendance?.festival;
  const isFestival = Boolean(festival || status === 'Festival');

  const handleClick = (e) => {
    if (isFestival) {
      triggerFestivalCelebration(e.clientX, e.clientY);
    }
    if (onClick) {
      onClick(e);
    }
  };

  const cellStyle = isFestival ? {} : {
    backgroundColor: status ? getAttendanceColor(status) : '#ffffff',
    borderLeft: status ? `3px solid ${getAttendanceBorderColor(status)}` : '1px solid #dee2e6'
  };

  const cellClasses = [
    'day-cell',
    !isCurrentMonth && 'not-current-month',
    isToday && 'today',
    status && 'has-attendance',
    isFestival && 'festival-rainbow-cell',
    onClick && 'clickable'
  ].filter(Boolean).join(' ');

  return (
    <div
      className={cellClasses}
      style={cellStyle}
      onClick={handleClick}
      role="button"
      tabIndex={isCurrentMonth ? 0 : -1}
      aria-label={`${date.toDateString()}${isFestival ? `, Festival: ${festival?.name || 'Festival'}` : status ? `, Status: ${status}` : ', No attendance'}`}
    >
      <div className="d-flex justify-content-between align-items-center">
        <div className="day-number">{dayNumber}</div>
        {isFestival && <span style={{ fontSize: '12px' }}>🌈</span>}
      </div>

      {festival && (
        <div className="festival-badge-rainbow" title={festival.name}>
          <span>🎉</span>
          <span style={{ maxWidth: '80px', overflow: 'hidden', textOverflow: 'ellipsis' }}>{festival.name}</span>
        </div>
      )}

      {status && (
        <div className="day-status">
          {isFestival ? (
            <span className="status-badge festival-rainbow-badge" title={festival?.name || 'Festival'}>
              🎉 Fest
            </span>
          ) : (
            <span className="status-badge">{status.charAt(0)}</span>
          )}
        </div>
      )}
      {attendance?.updatedAt && (
        <div className="edited-indicator" title="Manually Edited" />
      )}
      {attendance?.hasExtraWork && (
        <div
          className="extra-work-indicator"
          title={`Extra Work: In ${attendance.extraWork?.inTime || '-'} / Out ${attendance.extraWork?.outTime || '-'}`}
          style={{
            fontSize: '9px',
            backgroundColor: 'rgba(3, 105, 161, 0.12)',
            color: '#0284c7',
            borderRadius: '4px',
            padding: '1px 4px',
            fontWeight: '700',
            marginTop: '1px',
            display: 'inline-block'
          }}
        >
          ⚡ Extra
        </div>
      )}
      {attendance && (
        <div className="day-times-container">
          {attendance.inTime && attendance.inTime !== '-' && (
            <div className="day-time in-time">
              <small>In: {attendance.inTime}</small>
            </div>
          )}
          {attendance.outTime && attendance.outTime !== '-' && (
            <div className="day-time out-time">
              <small>Out: {attendance.outTime}</small>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default React.memo(DayCell);
